import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import FichajePanel from './worker/FichajePanel';
import Vacaciones from './worker/Vacaciones';
import Historial from './worker/Historial';

export default function WorkerView() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState('fichar');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col max-w-md mx-auto">
      {/* Header */}
      <header className="bg-mgh-blue-900 text-white px-4 pt-safe pb-0 shadow-lg">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-mgh-yellow-400 rounded-xl flex items-center justify-center">
              <span className="text-sm font-black text-mgh-blue-900">MGH</span>
            </div>
            <div>
              <div className="font-bold text-sm leading-tight">{user.nombre} {user.apellidos}</div>
              <div className="text-blue-200 text-xs">MGH Electricidad</div>
            </div>
          </div>
          <button
            onClick={logout}
            className="text-xs text-blue-200 hover:text-white px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors"
          >
            Salir
          </button>
        </div>

        {/* Tabs */}
        <div className="flex">
          <button
            onClick={() => setTab('fichar')}
            className={`tab-btn ${tab === 'fichar' ? 'tab-btn-active text-white border-mgh-yellow-400' : 'border-transparent text-blue-200 hover:text-white'}`}
          >
            🕐 Fichar
          </button>
          <button
            onClick={() => setTab('vacaciones')}
            className={`tab-btn ${tab === 'vacaciones' ? 'tab-btn-active text-white border-mgh-yellow-400' : 'border-transparent text-blue-200 hover:text-white'}`}
          >
            🏖️ Vacaciones
          </button>
          <button
            onClick={() => setTab('historial')}
            className={`tab-btn ${tab === 'historial' ? 'tab-btn-active text-white border-mgh-yellow-400' : 'border-transparent text-blue-200 hover:text-white'}`}
          >
            📋 Historial
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 p-4 overflow-y-auto">
        {tab === 'fichar' && <FichajePanel />}
        {tab === 'vacaciones' && <Vacaciones />}
        {tab === 'historial' && <Historial />}
      </main>

      {/* Footer */}
      <footer className="text-center text-xs text-gray-400 py-2 border-t border-gray-200">
        RD-ley 8/2019 · MGH Electricidad
      </footer>
    </div>
  );
}
